{
  "manual": {
    "button": "Manual",
    "title": "Manual del portal",
    "loading": "Cargando video…"
  }
}
